import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { NgClickOutsideDelayOutsideDirective } from 'ng-click-outside2';

@Component({
  selector: 'ux-select',
  templateUrl: './select.component.html',
  styleUrls: ['./select.component.less'],
  imports: [NgClickOutsideDelayOutsideDirective],
  // changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SelectComponent implements OnInit {
  @Input() items = [];
  @Output() onSelect = new EventEmitter<string[]>();

  selectedModel = [];
  isOpen = false;
  filter;
  private _value;

  @Input()
  set value(value) {
    this._value = value;
    this._initSelectedItems();
  }

  get value() {
    return this._value;
  }

  constructor() {}

  ngOnInit() {}

  select(item) {
    if (!item) {
      return;
    }

    const index = this.selectedModel.findIndex(model => model.id === item.id);

    if (index === -1) {
      this.selectedModel.push(item);
    } else {
      this.selectedModel.splice(index, 1);
    }

    // Обновляем _value на основе текущего selectedModel
    this._value = this.selectedModel.map(model => model.id);

    this.onSelect.emit(this._value);
  }

  open() {
    this.isOpen = true;
  }

  close() {
    this.isOpen = false;
  }

  toggle() {
    this.isOpen = !this.isOpen;
  }

  private _initSelectedItems() {
    this.selectedModel = [];
    if (Array.isArray(this._value)) {
      this._value = this._value.slice();
      this._value.forEach(id => {
        const foundItem = this.items.find(item => item.id === id);
        if (foundItem) {
          this.selectedModel.push(foundItem);
        }
      });
    } else if (this._value) {
      const foundItem = this.items.find(item => item.id === this._value);
      if (foundItem) {
        this.selectedModel.push(foundItem);
        this._value = [this._value];
      }
    }
  }
}
